export default class AbstractPlayerInterface {
  constructor(ref) {
    this.ref = ref;
  }
  load() {
    this.ref.current.load();
  }
  play() {
    this.ref.current.play();
  }
  pause() {
    if (!this.ref.current) return;
    this.ref.current.pause();
  }
  stop() {
    if (!this.ref.current) return;
    this.ref.current.pause();
  }
  setCurrentTime(currentTime) {
    this.ref.current.currentTime = currentTime;
  }
  getCurrentTime() {
    return this.ref.current.currentTime;
  }
  getDuration() {
    return this.ref.current.duration;
  }
}
